const DEFAULT_MIN_PASSWORD_LENGTH = 8;

type LoginValidationInput = {
  email: string;
  password: string;
};

type LoginValidationResult = {
  email?: string;
  password?: string;
};

export function validateLoginInput({
  email,
  password,
}: LoginValidationInput): LoginValidationResult {
  const errors: LoginValidationResult = {};
  const normalizedEmail = email.trim().toLowerCase();

  if (!normalizedEmail) {
    errors.email = "Informe o e-mail.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
    errors.email = "Informe um e-mail válido.";
  } else if (!isDomainAllowed(normalizedEmail)) {
    errors.email = "Este domínio de e-mail não está autorizado para login.";
  }

  if (!password) {
    errors.password = "Informe a senha.";
  } else if (password.length < DEFAULT_MIN_PASSWORD_LENGTH) {
    errors.password = `A senha precisa ter no mínimo ${DEFAULT_MIN_PASSWORD_LENGTH} caracteres.`;
  }

  return errors;
}

function isDomainAllowed(email: string): boolean {
  const rawDomains = process.env.NEXT_PUBLIC_ALLOWED_LOGIN_DOMAINS?.trim();
  if (!rawDomains) {
    return true;
  }

  const allowedDomains = rawDomains
    .split(",")
    .map((domain) => domain.trim().toLowerCase())
    .filter(Boolean);

  if (allowedDomains.length === 0) {
    return true;
  }

  const emailDomain = email.split("@")[1]?.toLowerCase();
  if (!emailDomain) {
    return false;
  }

  return allowedDomains.includes(emailDomain);
}

